import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const generateImgixUrl = (url) => {
  const res = url.replace('https://front.travpromobile.com/', 'https://imgtravpromobile.imgix.net/');
  const returnValue = res + '?fit=clip&w=200&h=auto';
  return returnValue;
};

const ContactViewCard = ({ name, description, telephone, town, mail, imageUrl }) => {
  return (
    <div className="contactView">
      <div className="contactView__Content">
        <img className="headshot" src={generateImgixUrl(imageUrl)} alt={`${name} - ${description}`} />
        <h1>{name}</h1>
        <h2>{description}</h2>
        <p>{town && <strong>{town}</strong>}</p>
        <a href={`tel:${telephone.trim()}`}>
          <FontAwesomeIcon icon={['fas', 'phone']} />+{telephone}
        </a>
        <a href={`mailto:${mail}`}>
          <FontAwesomeIcon icon={['fas', 'envelope']} />
          {mail}
        </a>
      </div>
    </div>
  );
};

export default ContactViewCard;
